import { Product_Obj, productListReducer, Variant_Obj } from "./reducers/product_list.reducers";
import { createStore, combineReducers, compose } from "redux";
import identityFn from './identity-fn';
import { routeReducer } from "./reducers/route.reducers";
import { Signup_Obj, signupReducer } from "./reducers/signup_input.reducers";
import { Signup_Details_Obj, signupDetailsReducer } from "./reducers/signup_details.reducers";
import { productReducer } from "./reducers/product.reducers";
import { variantReducer } from "./reducers/variant.reducer";
import { Checkout_Stage_Obj, checkoutReducer } from "./reducers/checkout_stage.reducers";
import { Current_Stage_Obj, currentCheckoutReducer } from "./reducers/current_checkout_stage.reducers";
import {  checkoutStateReducer, Checkout_State_Obj } from "./reducers/checkout_status.reducer";

export interface CustomAction {
    type: string;
    payload: any;
}

export interface StoreState {
    route: string | '/';
    product: Product_Obj | null;
    variant: Variant_Obj | null;
    product_list: Product_Obj[] | null;
    signup_form: Signup_Obj;
    signup_details: Signup_Details_Obj;
    checkout_stage: Checkout_Stage_Obj;
    current_checkout_stage: Current_Stage_Obj;
    checkout_state: Checkout_State_Obj;
}

export const reducers = combineReducers<StoreState>({
    route: routeReducer,
    product: productReducer,
    variant: variantReducer,
    product_list: productListReducer,
    signup_form: signupReducer,
    signup_details: signupDetailsReducer,
    checkout_stage: checkoutReducer,
    current_checkout_stage: currentCheckoutReducer,
    checkout_state: checkoutStateReducer
})

export const store = createStore(
    reducers,
    compose(
        (window as any).__REDUX_DEVTOOLS_EXTENSION__
          ? (window as any).__REDUX_DEVTOOLS_EXTENSION__()
          : identityFn,
      )
);


// WEBPACK FOOTER //
// ./src/store/index.tsx